export const translations = {
  en: {
    brand_sub: "General Trading LLC",
    nav_collection: "Categories",
    nav_products: "Products",
    nav_contact: "Contact",
    nav_all_categories: "All Categories",
    search_placeholder: "Search headphones, watches, chargers…",
    hero_badge: "Dubai · United Arab Emirates",
    hero_title: "Everything for your phone.",
    hero_sub:
      "Cambroo General Trading LLC sources, stocks and supplies premium mobile accessories — headphones, earphones, smart watches and more — for retailers and individuals across the Emirates.",
    hero_cta_explore: "Shop Now",
    hero_cta_enquire: "Trade Enquiry",
    hero2_title: "Free delivery across the UAE",
    hero2_sub: "Free shipping on all orders over AED 300 — same-week dispatch from Dubai.",
    feat_ship_t: "Free shipping",
    feat_ship_s: "On all orders over AED 300",
    feat_pay_t: "Secure payments",
    feat_pay_s: "Card · Cash on Delivery · Bank transfer",
    feat_wa_t: "WhatsApp support",
    feat_wa_s: "Sat–Thu, 9:00 – 18:00",
    cats_heading: "Shop by Category",
    cat_deals: "Deals",
    prod_title: "In stock, in Dubai.",
    coming_soon_title: "Coming soon",
    coming_soon_sub: "We're stocking this category. Message us on WhatsApp for availability and bulk pricing.",
    load_more: "Load more products",
    deal_title: "Deals of the Day",
    deal_sub: "Best sellers at today's prices — ends at midnight",
    deal_ends: "Ends in",
    new_arrivals: "New Arrivals",
    shop_all: "Shop all",
    search_results: "Search results",
    search_empty: "No products match your search",
    search_empty_hint: "Try different keywords, or browse the categories",
    pdp_description: "Description",
    badge_delivery: "Free Delivery",
    badge_cod: "Cash on Delivery",
    badge_warranty: "1 Year Warranty",
    badge_returns: "Easy Returns",
    express: "express",
    wishlist_title: "My Wishlist",
    wishlist_empty: "Your wishlist is empty.",
    wishlist_empty_sub: "Tap the heart on any product to save it here.",
    wishlist_start: "Start Shopping",
    deliver_to: "Deliver to",
    nav_orders: "Orders",
    nav_wishlist: "Wishlist",
    reviews_title: "Customer Reviews",
    verified_buyer: "Verified Buyer",
    products_count: "products",
    pdp_home: "Home",
    pdp_specs: "Specifications",
    pdp_related: "You may also like",
    pdp_delivery: "Free delivery on orders over AED 300 · Cash on Delivery available",
    pdp_ask: "Ask about this product",
    pdp_not_found: "Product not found",
    pdp_back: "Back to products",
    tab_all: "All",
    add_to_cart: "Add to Cart",
    added: "Added",
    toast_added: "added to cart",
    toast_view: "View",
    qv_specs: "Specifications",
    qv_qty: "Quantity",
    cart_title: "Your Cart",
    cart_empty: "Your cart is empty.",
    cart_empty_sub: "Add a few pieces from the collection — wholesale enquiries welcome.",
    cart_subtotal: "Subtotal",
    cart_checkout: "Proceed to Checkout",
    cart_note: "Shipping calculated at checkout · Secure payment via Stripe",
    cart_free: "Free shipping on orders over AED 300",
    co_label: "Secure Checkout",
    co_title: "Complete your order",
    co_step1: "Step 1 of 2 — Delivery",
    co_step2: "Step 2 of 2 — Review & Pay",
    co_name: "Full name",
    co_email: "Email address",
    co_phone: "Phone (+971 ...)",
    co_address: "Street address",
    co_subtotal: "Subtotal",
    co_shipping: "Shipping",
    co_free: "Free",
    co_total: "Total",
    co_continue: "Review Order",
    co_pay: "Pay Securely with Stripe",
    co_back: "Back",
    co_secure: "Encrypted payment via Stripe. Your order is created only after payment succeeds.",
    co_redirecting: "Redirecting to secure payment…",
    co_error: "Could not start payment. Please try again.",
    contact_label: "Enquiries",
    contact_title_1: "Let’s talk",
    contact_title_2: "trade.",
    contact_sub:
      "Wholesale pricing, bulk orders, or a single piece — send us a note and the Cambroo team will respond within one working day.",
    contact_address: "504, NBQ Bank Building, Burjman, Bur Dubai",
    contact_hours: "Saturday – Thursday, 9:00 – 18:00",
    contact_phone: "+971 56 849 8289",
    contact_name: "Your name *",
    contact_email: "Email address *",
    contact_company: "Company (optional)",
    contact_message: "Tell us what you need — quantities, categories, delivery emirate… *",
    contact_submit: "Send Enquiry",
    contact_sending: "Sending",
    contact_success: "Enquiry sent — we will reply within one working day.",
    contact_error: "Could not send your enquiry. Please try again.",
    footer_tagline:
      "Premium mobile accessories, traded from the heart of Deira to the whole of the Emirates and the GCC.",
    footer_explore: "Explore",
    footer_office: "Head Office",
    footer_brand: "CAMBROO",
    footer_rights: "© 2026 Cambroo General Trading LLC. All rights reserved.",
    footer_prices: "Prices in UAE Dirham (AED). Secure payments by Stripe.",
    wa_tooltip: "Chat with us on WhatsApp",
    ps_verifying: "Confirming your payment…",
    ps_verifying_sub: "We are verifying the transaction with Stripe.",
    ps_confirmed: "Shukran, order received.",
    ps_confirmed_sub: "Payment successful. Our team will contact you within one working day to confirm delivery.",
    ps_ref: "Order reference",
    ps_pending: "Payment still processing",
    ps_pending_sub: "Stripe has not confirmed the payment yet. If the amount was deducted, it will reflect shortly or be refunded automatically.",
    ps_home: "Back to Store",
    pc_title: "Payment cancelled",
    pc_sub: "No amount was charged. You can return and complete your order anytime.",
    pc_back: "Back to Store",
    pm_label: "Payment method",
    acc_required_title: "Sign in to continue",
    acc_required_sub: "Create a free account to place your order and track it anytime.",
    acc_signin_cta: "Sign In / Create Account",
    acc_login: "Sign In",
    acc_register: "Create Account",
    acc_name: "Full name",
    acc_email: "Email address",
    acc_password: "Password (min 8 characters)",
    acc_phone: "Phone (+971 ...)",
    acc_my_orders: "My Orders",
    acc_no_orders: "No orders yet — your orders will appear here.",
    acc_logout: "Sign Out",
    acc_welcome: "Welcome back",
    acc_no_account: "New here? Create an account",
    acc_have_account: "Already have an account? Sign in",
    nav_account: "Account",
    pm_card: "Card — secure via Stripe",
    pm_cod: "Cash on Delivery",
    pm_bank: "Bank Transfer",
    co_place_cod: "Place Order — Pay on Delivery",
    co_place_bank: "Place Order — Get Bank Details",
    os_title: "Order placed. Shukran!",
    os_ref: "Order reference",
    os_cod_note: "Pay in cash when your order arrives. Our team will call you to confirm delivery.",
    os_bank_note: "Transfer the total to the account below, then share the receipt with us on WhatsApp or by replying to our email.",
    os_bank_name: "Bank",
    os_bank_account: "Account name",
    os_bank_iban: "IBAN",
    os_done: "Continue Browsing",
  },
  ar: {
    brand_sub: "للتجارة العامة ذ.م.م",
    nav_collection: "الفئات",
    nav_products: "المنتجات",
    nav_contact: "تواصل معنا",
    nav_all_categories: "كل الفئات",
    search_placeholder: "ابحث عن سماعات، ساعات، شواحن…",
    hero_badge: "دبي · الإمارات العربية المتحدة",
    hero_title: "كل ما يحتاجه هاتفك.",
    hero_sub:
      "كامبرو للتجارة العامة ذ.م.م تختار وتخزّن وتوفر أفضل إكسسوارات الهواتف — سماعات رأس، سماعات أذن، ساعات ذكية والمزيد — لتجار التجزئة والأفراد في جميع أنحاء الإمارات.",
    hero_cta_explore: "تسوق الآن",
    hero_cta_enquire: "استفسار تجاري",
    hero2_title: "توصيل مجاني في جميع أنحاء الإمارات",
    hero2_sub: "شحن مجاني لجميع الطلبات فوق 300 درهم — شحن خلال نفس الأسبوع من دبي.",
    feat_ship_t: "شحن مجاني",
    feat_ship_s: "لجميع الطلبات فوق 300 درهم",
    feat_pay_t: "دفع آمن",
    feat_pay_s: "بطاقة · الدفع عند الاستلام · تحويل بنكي",
    feat_wa_t: "دعم واتساب",
    feat_wa_s: "السبت–الخميس، 9:00 – 18:00",
    cats_heading: "تسوق حسب الفئة",
    cat_deals: "عروض",
    prod_title: "متوفر في دبي.",
    coming_soon_title: "قريباً",
    coming_soon_sub: "نعمل على توفير هذه الفئة. راسلنا عبر واتساب لمعرفة التوفر وأسعار الجملة.",
    load_more: "عرض المزيد من المنتجات",
    deal_title: "عروض اليوم",
    deal_sub: "الأكثر مبيعاً بأسعار اليوم — تنتهي منتصف الليل",
    deal_ends: "ينتهي خلال",
    new_arrivals: "وصل حديثاً",
    shop_all: "تسوق الكل",
    search_results: "نتائج البحث",
    search_empty: "لا توجد منتجات مطابقة لبحثك",
    search_empty_hint: "جرّب كلمات مختلفة أو تصفح الفئات",
    pdp_description: "الوصف",
    badge_delivery: "توصيل مجاني",
    badge_cod: "الدفع عند الاستلام",
    badge_warranty: "ضمان سنة",
    badge_returns: "إرجاع سهل",
    express: "سريع",
    wishlist_title: "قائمة المفضلة",
    wishlist_empty: "قائمتك المفضلة فارغة.",
    wishlist_empty_sub: "اضغط على القلب في أي منتج لحفظه هنا.",
    wishlist_start: "ابدأ التسوق",
    deliver_to: "التوصيل إلى",
    nav_orders: "الطلبات",
    nav_wishlist: "المفضلة",
    reviews_title: "آراء العملاء",
    verified_buyer: "مشتري موثّق",
    products_count: "منتجاً",
    pdp_home: "الرئيسية",
    pdp_specs: "المواصفات",
    pdp_related: "قد يعجبك أيضاً",
    pdp_delivery: "توصيل مجاني للطلبات فوق 300 درهم · الدفع عند الاستلام متاح",
    pdp_ask: "اسأل عن هذا المنتج",
    pdp_not_found: "المنتج غير موجود",
    pdp_back: "العودة إلى المنتجات",
    tab_all: "الكل",
    add_to_cart: "أضف إلى السلة",
    added: "تمت الإضافة",
    toast_added: "أُضيف إلى السلة",
    toast_view: "عرض",
    qv_specs: "المواصفات",
    qv_qty: "الكمية",
    cart_title: "سلة التسوق",
    cart_empty: "سلتك فارغة.",
    cart_empty_sub: "أضف بعض القطع من المجموعة — نرحب بطلبات الجملة.",
    cart_subtotal: "المجموع الفرعي",
    cart_checkout: "إتمام الشراء",
    cart_note: "الشحن يُحسب عند إتمام الطلب · دفع آمن عبر Stripe",
    cart_free: "شحن مجاني للطلبات فوق 300 درهم",
    co_label: "دفع آمن",
    co_title: "أكمل طلبك",
    co_step1: "الخطوة 1 من 2 — التوصيل",
    co_step2: "الخطوة 2 من 2 — المراجعة والدفع",
    co_name: "الاسم الكامل",
    co_email: "البريد الإلكتروني",
    co_phone: "الهاتف (‎+971 ...)",
    co_address: "عنوان الشارع",
    co_subtotal: "المجموع الفرعي",
    co_shipping: "الشحن",
    co_free: "مجاني",
    co_total: "الإجمالي",
    co_continue: "مراجعة الطلب",
    co_pay: "ادفع بأمان عبر Stripe",
    co_back: "رجوع",
    co_secure: "دفع مشفر وآمن عبر Stripe. يتم إنشاء الطلب فقط بعد نجاح الدفع.",
    co_redirecting: "جاري تحويلك إلى صفحة الدفع الآمنة…",
    co_error: "تعذر بدء عملية الدفع. حاول مرة أخرى.",
    contact_label: "الاستفسارات",
    contact_title_1: "لنتحدث",
    contact_title_2: "تجارة.",
    contact_sub: "أسعار الجملة أو الطلبات الكبيرة أو قطعة واحدة — أرسل لنا رسالة وسيرد عليك فريق كامبرو خلال يوم عمل واحد.",
    contact_address: "٥٠٤، مبنى بنك NBQ، برجمان، بر دبي",
    contact_hours: "السبت – الخميس، 9:00 – 18:00",
    contact_phone: "+971 56 849 8289",
    contact_name: "اسمك *",
    contact_email: "بريدك الإلكتروني *",
    contact_company: "الشركة (اختياري)",
    contact_message: "أخبرنا بما تحتاج — الكميات، الفئات، إمارة التوصيل… *",
    contact_submit: "أرسل الاستفسار",
    contact_sending: "جاري الإرسال",
    contact_success: "تم إرسال الاستفسار — سنرد خلال يوم عمل واحد.",
    contact_error: "تعذر إرسال الاستفسار. حاول مرة أخرى.",
    footer_tagline: "إكسسوارات هواتف فاخرة، من قلب ديرة إلى كل الإمارات ودول الخليج.",
    footer_explore: "استكشف",
    footer_office: "المقر الرئيسي",
    footer_brand: "كامبرو",
    footer_rights: "© 2026 كامبرو للتجارة العامة ذ.م.م. جميع الحقوق محفوظة.",
    footer_prices: "الأسعار بالدرهم الإماراتي. دفع آمن عبر Stripe.",
    wa_tooltip: "تحدث معنا عبر واتساب",
    ps_verifying: "جاري تأكيد الدفع…",
    ps_verifying_sub: "نتحقق من العملية مع Stripe.",
    ps_confirmed: "شكراً، تم استلام طلبك.",
    ps_confirmed_sub: "تم الدفع بنجاح. سيتواصل معك فريقنا خلال يوم عمل واحد لتأكيد التوصيل.",
    ps_ref: "رقم الطلب",
    ps_pending: "الدفع قيد المعالجة",
    ps_pending_sub: "لم يؤكد Stripe الدفع بعد. إذا تم خصم المبلغ فسيظهر قريباً أو يُعاد تلقائياً.",
    ps_home: "العودة للمتجر",
    pc_title: "تم إلغاء الدفع",
    pc_sub: "لم يتم خصم أي مبلغ. يمكنك العودة وإتمام طلبك في أي وقت.",
    pc_back: "العودة للمتجر",
    pm_label: "طريقة الدفع",
    acc_required_title: "سجّل الدخول للمتابعة",
    acc_required_sub: "أنشئ حساباً مجانياً لإتمام طلبك وتتبعه في أي وقت.",
    acc_signin_cta: "تسجيل الدخول / إنشاء حساب",
    acc_login: "تسجيل الدخول",
    acc_register: "إنشاء حساب",
    acc_name: "الاسم الكامل",
    acc_email: "البريد الإلكتروني",
    acc_password: "كلمة المرور (٨ أحرف على الأقل)",
    acc_phone: "الهاتف (‎+971 ...)",
    acc_my_orders: "طلباتي",
    acc_no_orders: "لا توجد طلبات بعد — ستظهر طلباتك هنا.",
    acc_logout: "تسجيل الخروج",
    acc_welcome: "مرحباً بعودتك",
    acc_no_account: "جديد هنا؟ أنشئ حساباً",
    acc_have_account: "لديك حساب؟ سجّل الدخول",
    nav_account: "حسابي",
    pm_card: "بطاقة — دفع آمن عبر Stripe",
    pm_cod: "الدفع عند الاستلام",
    pm_bank: "تحويل بنكي",
    co_place_cod: "أكّد الطلب — الدفع عند الاستلام",
    co_place_bank: "أكّد الطلب — عرض التفاصيل البنكية",
    os_title: "تم استلام طلبك. شكراً!",
    os_ref: "رقم الطلب",
    os_cod_note: "ادفع نقداً عند وصول طلبك. سيتصل بك فريقنا لتأكيد التوصيل.",
    os_bank_note: "حوّل المبلغ الإجمالي إلى الحساب أدناه، ثم شارك إيصال التحويل معنا عبر واتساب أو بالرد على بريدنا.",
    os_bank_name: "البنك",
    os_bank_account: "اسم الحساب",
    os_bank_iban: "آيبان",
    os_done: "متابعة التسوق",
  },
};

export const EMIRATE_NAMES = {
  en: {
    Dubai: "Dubai",
    "Abu Dhabi": "Abu Dhabi",
    Sharjah: "Sharjah",
    Ajman: "Ajman",
    "Ras Al Khaimah": "Ras Al Khaimah",
    Fujairah: "Fujairah",
    "Umm Al Quwain": "Umm Al Quwain",
  },
  ar: {
    Dubai: "دبي",
    "Abu Dhabi": "أبوظبي",
    Sharjah: "الشارقة",
    Ajman: "عجمان",
    "Ras Al Khaimah": "رأس الخيمة",
    Fujairah: "الفجيرة",
    "Umm Al Quwain": "أم القيوين",
  },
};
